import { render } from "./Home.vue?vue&type=template&id=ee89cb84&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=ee89cb84&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee89cb84"]])

export default __exports__